import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './lib/router'
import { installFilters } from './lib/filters'
import { NoticePlugin } from '@/lib/plugins/notice'
import { ConfirmPlugin } from '@/lib/plugins/confirm'
import { installInputFormat } from './lib/directives/inputFormat'
import { installParantheses } from './lib/directives/parantheses'
import { installNumberFormat } from './lib/directives/numberFormat'
import { installTippy } from './lib/directives/tippy'

const app = createApp(App)
const head = createHead()
const pinia = createPinia()

app.use(head)
app.use(pinia)
app.use(router)
app.use(NoticePlugin)
app.use(ConfirmPlugin)

installFilters(app)
installInputFormat(app)
installParantheses(app)
installNumberFormat(app)
installTippy(app)

app.mount('#app')
